'use client';

import Autoplay from 'embla-carousel-autoplay';
import * as React from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../ui/Carousel';
import { Button } from '../Button';

type HeroSectionProps = {
  banner?: {
    id: string;
    featuredAsset?: {
      preview: string;
    } | null;
  } | null;
};

const HeroSection = ({ banner }: HeroSectionProps) => {
  const plugin = React.useRef(
    Autoplay({ delay: 4000, stopOnInteraction: true }),
  );

  const slides = banner?.featuredAsset?.preview
    ? [banner.featuredAsset.preview]
    : [];

  if (!slides.length) {
    return null;
  }

  return (
    <section className="container w-full relative overflow-hidden">
      <Carousel
        plugins={[plugin.current]}
        className="w-full"
        opts={{ loop: true }}
        onMouseEnter={plugin.current.stop}
        onMouseLeave={plugin.current.reset}
      >
        <CarouselContent>
          {slides.map((src, index) => (
            <CarouselItem key={index}>
              <div className="overflow-hidden relative">
                <img
                  src={src}
                  alt={`Promotional banner slide ${index + 1}`}
                  className="h-[210px]  sm:h-[300px] md:h-[350px] lg:h-[800px] w-full object-cover object-bottom sm:object-center"
                />
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>

        {/* <div className="absolute bottom-8 left-8">
          <Button className="bg-primary text-white px-6 py-2 rounded-lg hover:bg-red-700">
            Shop Now
          </Button>
        </div> */}

        <div className="absolute bottom-8 right-16 flex space-x-2 bg-red-600 p-2 rounded-lg">
          <CarouselPrevious className="static text-white hover:bg-red-700" />
          <CarouselNext className="static text-white hover:bg-red-700" />
        </div>
      </Carousel>
    </section>
  );
};

export default HeroSection;
